export default {
  Auth: {
    TOKEN_UPDATED: 'auth:token-updated',
    OPEN_AUTH_WINDOW: 'auth:open-auth-window',
    CALENDAR_ACCOUNT_CONNECTED: 'auth:calendar-account-connected'
  },
  App: {
    SWITCH_ENVIRONMENT: 'app:switch-environment',
    OPEN_EXTERNAL_LINK: 'app:open-external-link',
    SHOW_MAIN_WINDOW: 'app:show-main-window',
    // Snapshot of the global quick-search hotkey state, so the renderer can
    // reconcile (and warn on conflict) on mount. Named "launcher" for history;
    // the hotkey now opens the tray's search rather than a separate overlay.
    LAUNCHER_STATUS: 'app:launcher-status',
    // Grow/shrink the tray popover: booking needs more room for the event form
    // and its larger poppers than the compact agenda/search view.
    SET_TRAY_EXPANDED: 'app:set-tray-expanded',
    // Renderer reports the measured pixel height of a self-sizing tray panel
    // (the upsell / login / loading states), or null to hand sizing back to the
    // user's dragged height. Those panels have no scrollable content, so a
    // window sized for the agenda leaves a large empty box around them.
    SET_TRAY_FITTED_HEIGHT: 'app:set-tray-fitted-height',
    // Renderer reports whether the tray is currently showing search, so the
    // global hotkey can switch an already-open tray to search instead of
    // hiding it — and only toggle it closed when search is already up.
    SET_TRAY_SEARCHING: 'app:set-tray-searching',
    // Renderer asks the main process to hide the tray popover — used by Esc on
    // the agenda (home) screen, where there's no search/booking to back out of,
    // so Esc dismisses the whole tray instead.
    HIDE_TRAY: 'app:hide-tray',
    // Renderer pushes a short "next event · countdown" string for the macOS
    // menu-bar tray title (empty string clears it). macOS-only in the main
    // process; a no-op elsewhere.
    SET_TRAY_TITLE: 'app:set-tray-title',
    CLEAR_INDEXED_DB: 'app:clear-indexed-db',
    LOGOUT: 'app:logout',
    QUIT: 'app:quit'
  },
  Menu: {
    NEW_EVENT: 'calendar:new-event',
    NEW_NOTE: 'notes:new-note',
    SEARCH: 'search:open',
    OPEN_PREFERENCES: 'preferences:open',
    EXECUTE_ROLE: 'menu:execute-role'
  },
  Preferences: {
    SET_OPEN_AT_LOGIN: 'preferences:set-open-at-login'
  },
  Billing: {
    CHECKOUT_COMPLETE: 'billing:checkout-complete'
  },
  Calendar: {
    STATUS: 'calendar:status',
    STATUS_CHANGED: 'calendar:status-changed',
    POLLED: 'calendar:polled',
    WORKSPACE_ETAG_OBSERVED: 'calendar:workspace-etag-observed'
  },
  EventBus: {
    SEND: 'event-bus:send:',
    BROADCAST: 'event-bus:broadcast'
  },
  Google: {
    CALL_API: 'google:call-api'
  },
  Notifications: {
    SCHEDULE: 'notifications:schedule',
    SHOW: 'notifications:show',
    RESIZE: 'notifications:resize',
    DISMISS: 'notifications:dismiss',
    HIDE: 'notifications:hide',
    READY: 'notifications:ready'
  },
  Updater: {
    CHECKING_FOR_UPDATE: 'updater:checking-for-update',
    UPDATE_AVAILABLE: 'updater:update-available',
    UPDATE_NOT_AVAILABLE: 'updater:update-not-available',
    DOWNLOAD_PROGRESS: 'updater:download-progress',
    UPDATE_DOWNLOADED: 'updater:update-downloaded',
    QUIT_AND_INSTALL: 'updater:quit-and-install',
    ERROR: 'updater:error',
    // Pushed when the updater can't run (e.g. app-update.yml missing on a
    // damaged install); GET_UPDATER_STATUS lets the renderer pull current state.
    UPDATER_UNAVAILABLE: 'updater:unavailable',
    GET_UPDATER_STATUS: 'updater:get-status'
  },
  Window: {
    MINIMIZE: 'window:minimize',
    MAXIMIZE: 'window:maximize',
    UNMAXIMIZE: 'window:unmaximize',
    CLOSE: 'window:close',
    IS_MAXIMIZED: 'window:isMaximized',
    MAXIMIZED: 'window:maximized',
    UNMAXIMIZED: 'window:unmaximized',
    TOGGLE_DEV_TOOLS: 'window:toggle-dev-tools',
    FOCUSED: 'window:focused',
    BLURRED: 'window:blurred'
  },
  Analytics: {
    IDENTIFY_USER: 'analytics:identify-user',
    TRACK_EVENT: 'analytics:track-event'
  }
} as const

// Known event bus events.
export const EventBus = {
  SHOW_PREFERENCES: 'show-preferences',
  RESET_VIEW_STATE: 'reset-view-state',
  // Broadcast to the tray when the global quick-search hotkey opens it, so the
  // renderer focuses its search input for immediate typing.
  TRAY_FOCUS_SEARCH: 'tray-focus-search',
  // Broadcast when the OS refuses to register the global quick-search hotkey
  // (reserved or claimed by another app), so the renderer can warn the user.
  GLOBAL_SHORTCUT_CONFLICT: 'global-shortcut-conflict'
}
